import getStore from '../store/store';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import getLocationSuggestions from 'owa-location-common-well/lib/utils/getLocationSuggestions';
import requestCurrentPosition from 'owa-location-common-well/lib/utils/requestCurrentPosition';
import { onLocationSuggestionsStateChanged } from './onLocationSuggestionsStateChanged';
import SearchMode from 'owa-location-common-well/lib/store/schema/SearchMode';
import { isFeatureEnabled } from 'owa-feature-flags';

/*
 * @param event: the calendar event
 * @param searchMode: the request search mode for the location suggestions
 */
export function populateLocationSuggestions(event?: CalendarEvent, searchMode?: SearchMode) {
    if (isFeatureEnabled('cal-mf-locationShowNearByRooms')) {
        requestCurrentPosition(position => {
            getLocationSuggestions(
                '' /* queryString */,
                () => getStore().locationSuggestionsState,
                {
                    event: event,
                    searchMode: searchMode,
                    currentDevicePosition: position,
                },
                onLocationSuggestionsStateChanged
            );
        });
    } else {
        getLocationSuggestions(
            '' /* queryString */,
            () => getStore().locationSuggestionsState,
            {
                event: event,
                searchMode: searchMode,
                currentDevicePosition: null,
            },
            onLocationSuggestionsStateChanged
        );
    }
}
